exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-vxe-checkbox.no-animation .ant-checkbox-inner,\n.j-vxe-checkbox.no-animation .ant-checkbox-inner::after {\n  -webkit-transition: none !important;\n  transition: none !important;\n}\n", ""]);

// exports
